<template>
    <v-row>
        <v-col cols="12" sm="12">
            <v-card>
                <v-card-title class="justify-center text-h5">
                    <strong>{{ $t('Categorías más vendidos en') }} {{ money }}</strong>
                </v-card-title>
                <v-card-text>
                    <line-chart
                        v-if="loading2"
                        :datasets="graphSales"
                        :height="height"
                    ></line-chart>
                </v-card-text>
                <v-card-actions>
                    <v-row class="mt-2" no-gutters>
                        <v-col cols="6">
                            <v-menu
                                v-model="menu3"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dateInit2"
                                        :label="$t('Fecha inicial')"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        color="orange"
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateInit2"
                                    @input="menu3 = false"
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="6">
                            <v-menu
                                v-model="menu4"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="dateEnd2"
                                        :label="$t('Fecha final')"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        outlined
                                        dense
                                        color="orange"
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateEnd2"
                                    @input="menu4 = false"
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" class="text-right">
                            <v-btn
                                color="primary"
                                class="mb-5"
                                @click="getGraphCategories"
                                :loading="!loading2"
                            >{{ $t('Filtrar') }}</v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            loading2: false,
            menu1: false,
            menu2: false,
            dateInit: '',
            dateEnd: '',
            menu3: false,
            menu4: false,
            dateInit2: '',
            dateEnd2: '',
            graphCats: {
                labels: [],
                values: []
            },
            graphSales: [],
        }
    },
    props: ['money', 'type'],
    mounted() {
        this.getGraphCategories()
    },
    methods: {
        async getGraphCategories() {
            this.loading2 = false
            await axios.post(`/admin/categories-prices?init=${this.dateInit2}&end=${this.dateEnd2}&type=${JSON.stringify(this.type)}`, {})
            .then((response) => {
                // console.log(response);
                // this.graphSales.labels = response.data.labels
                this.graphSales = response.data
                this.loading2 = true
            })
            .catch((error) => {
                // console.log(error);
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                }
            })
        },
    },
    computed: {
        height () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 300
                case 'sm': return 300
                default: return 150;
            }
        },
    },
}
</script>
